import { BaseFilter } from './base-filter';
import Project from './project';


export class SelectionFilter extends BaseFilter {
  constructor(option: any) {
    super(option)
    this.category = option['category'];
  }

  public filter(project: Project) {
    let feature = project.getLatestFeature();
    // ? TODO: Refactoring these the following condition
    // ? TODO: create new filter class based on the BaseFilter to handle the logic
    if (this.category === 'agency') {
      return feature.properties['lead_agency'] === this.value ||
      feature.properties['all_agencies'].indexOf(this.value) !== -1;
    }
    if (this.category === 'federal_performance_measure') {
      if (feature.properties['federal_performance_measure'] === null) {
        return false;
      }
      return feature.properties['federal_performance_measure'].indexOf(this.value) !== -1;
    }
    return feature.properties[this.category] === this.value;
  }
}
